import type { BrandColors } from '@/shared/ui/theme/tokens';

interface CurrentProfileBadgeProps {
  profileName: string;
  C: BrandColors;
}

export function CurrentProfileBadge({ profileName, C }: CurrentProfileBadgeProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '4px 10px 4px 6px',
        borderRadius: 999,
        background: `${C.blue}10`,
        border: `1px solid ${C.blue}28`,
        cursor: 'default',
      }}
    >
      <div
        style={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: C.blue,
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 21h18" />
          <path d="M5 21V7l8-4v18" />
          <path d="M19 21V11l-6-4" />
          <path d="M9 9h.01M9 12h.01M9 15h.01M9 18h.01" />
        </svg>
      </div>
      <span style={{ fontSize: 12, fontWeight: 700, color: '#000', letterSpacing: '.02em' }}>
        {profileName}
      </span>
    </div>
  );
}
